import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { TraceHistory } from 'types';

export const getHistoryByLimit = async (
  snapshotId: number,
  limit: number | undefined
): Promise<TraceHistory[]> => {
  const { data } = await axios.get(
    `/api/snapshots/${snapshotId}/history/limit/${limit}`
  );
  return data as TraceHistory[];
};

type QueryFnType = typeof getHistoryByLimit;

type UseTraceHistoryLimitOptions = {
  config?: QueryConfig<QueryFnType>;
  snapshotId: number;
  limit: number | undefined;
};

export const useTraceHistoryByLimit = ({
  snapshotId,
  limit,
  config,
}: UseTraceHistoryLimitOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['snapshot', snapshotId, 'history', limit],
    queryFn: () => getHistoryByLimit(snapshotId, limit),
    enabled: limit !== undefined,
    ...config,
  });
};
